import styled from 'styled-components';
import colors from '../../../_colors.module.scss';
import { BdsTypo, BdsIcon } from 'blip-ds/dist/blip-ds-react';

export const Container = styled.div`
    margin-left: 10%;
    margin-right: 10%;
`;

export const IntroductionContent = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    padding-top: 5rem;
`;

export const TextArea = styled.div`
    display: flex;
    flex-direction: column;
    width: 60%;
    gap: 1.5rem;
    padding: 1.5rem 0 1.5rem 6rem;
`;

export const CallsImgContent = styled.div`
    position: relative;
    width: 80%;
`;

export const CallsImg = styled.img`
    position: relative; 
    width: 50%;
    left: 40%;
`;

export const ModalButton = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

export const CallsAudioImgContainer = styled.div`
    position: absolute;
    z-index: 1;
    width: 340px;
    height: 150px;
    top: 60%;
    left: 35%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CallsAudioPlayerImg = styled.img`
    position: absolute;
`;

export const FeaturesContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

export const CallsFeatures = styled.div` 
    background-color: #0C50C5;
    width: 100%;
    display: flex;
    flex-direction: row;
    height: 360px;
    border-radius: 10px;
    align-items: center;
    justify-content: center;
`;

export const IllustrationContainer = styled.div`
    width: 225px;
`;

export const FeatureText = styled(BdsTypo)`
    color: ${colors.Surface1};
`;

export const CheckIcon = styled(BdsIcon)`
    color: #6BFFBC;
`;

export const Title = styled.div`
    width: 100%;
    margin-top: 2rem;
`;

export const Divider = styled.div`
  border-bottom: 1px solid ${colors.Surface3};
  margin-top: 2rem;
  margin-bottom: 3rem;
`;

export const ReadMoreButton = styled.div`
  background-color: ${colors.Surface1};
  border-radius: 8px;
`;

export const DataContainer = styled.div`
  background-color: ${colors.System};
  border-radius: 8px;
  width: 35%;
`;